(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$mdDialog', 'User', 'JhiLanguageService', 'toastr', 'Commissione',
        'CommissioneRuolo', 'SoggettoEsterno', 'Settore', 'AUTHORITIES', '$state', '$translate', 'Atto', '$scope', 'TipoDocumento', 'Sezione'];

    function UserManagementDialogController($mdDialog, User, JhiLanguageService, toastr, Commissione, CommissioneRuolo,
            SoggettoEsterno, Settore, AUTHORITIES, $state, $translate, Atto, $scope, TipoDocumento, Sezione) {
        var vm = this;
        vm.windowsAuthEnabled = vm.env.windowsAuthEnabled;
        vm.user = vm.entity;
        vm.isExternalDomainUser = false;
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.settori = [];
        vm.commissioni = [];
        vm.commissioniRuoli = [];
        vm.soggettiEsterni = [];
        vm.tipiDocumento = [];
        vm.user.langKey = 'it';
        vm.legislature = [];
        vm.selectedLegislaturaIndex = 0;
        vm.filterSoggettoStoricizzato = filterSoggettoStoricizzato;
        vm.nomiSezione = [];

        initController();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        vm.isCommissionUser = function (legislatura) {
            if(!legislatura) {
                return hasAuthority('ROLE_COMMISSIONE');
            } else {
                var legiAuth = vm.getLegislaturaAuthorities(legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_COMMISSIONE') > -1;
                } else {
                    return false;
                }
            }
        };

        vm.isExternalUser = function (legislatura) {
            if(!legislatura) {
                return hasAuthority('ROLE_EXTERNAL');
            } else {
                var legiAuth = vm.getLegislaturaAuthorities(legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_EXTERNAL') > -1;
                } else {
                    return false;
                }    
            }
        };

        vm.isSectorUser = function () {
            return hasAuthority('ROLE_SETTORE');
        };

        vm.isSectionUser = function () {
            return hasAuthority('ROLE_SECTION');
        };

        vm.setUserData = function (ldapUser) {
            if (ldapUser) {
                vm.user.login = ldapUser.principal;
                vm.user.firstName = ldapUser.firstName;
                vm.user.lastName = ldapUser.lastName;
                vm.user.email = ldapUser.email;
            }
        };

        vm.searchLdapUsers = function (text) {
            if (!text || text.length < 3) {
                return [];
            }
            return vm.ldapUsers.filter(createFilterFor(text));
        };


        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(user) {
                return ((user.lastName && user.lastName.toString().toLowerCase().indexOf(lowercaseQuery) === 0)
                        || (user.firstName && user.firstName.toString().toLowerCase().indexOf(lowercaseQuery) === 0)
                        || (user.principal && user.principal.toString().toLowerCase().indexOf(lowercaseQuery) === 0));
            };
        }

        function hasAuthority(authority) {
            return vm.user.authorities !== null
                    && angular.isDefined(vm.user.authorities)
                    && vm.user.authorities.indexOf(authority) > -1;
        }

        function clear() {
            $mdDialog.cancel();
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $mdDialog.cancel();
            $state.go('user-management', null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;

            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                if(vm.isExternalDomainUser){
                    vm.user.fiscalCode = vm.user.login;
                }
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function initController() {

            // Array di authorities permanenti
            vm.authorities = [];
            vm.authorities.push("ROLE_USER");
            angular.forEach(AUTHORITIES, function(auth) {
                vm.authorities.push(auth.name);
            });

            // Authorities specifiche per legislatura
            vm.legiAuthorities = ["ROLE_COMMISSIONE","ROLE_AULA","ROLE_EXTERNAL"];
            // Rimuove authority di legislatura 
            angular.forEach(vm.legiAuthorities, function(legiAuth) {
                var index = vm.authorities.indexOf(legiAuth);
                if (index !== -1) {
                    vm.authorities.splice(index, 1);
                }
            });
            
            // load settori
            Settore.query({}, function (settori) {
                vm.settori = settori;
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei settori: ' + error.message, 'Errore!');
            });

            // load commissioni
            Commissione.query({includeHidden : true}, function (commissioni) {
                vm.commissioni = commissioni;
            }, function (error) {
                toastr.error('Impossibile reperire la lista delle commissioni: ' + error.message, 'Errore!');
            });

            // load commissioni ruoli
            CommissioneRuolo.query({}, function (commissioniRuoli) {
                vm.commissioniRuoli = commissioniRuoli;
                normalizzaCommissioniRuoloAssociato();
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei ruoli delle commissioni: ' + error.message, 'Errore!');
            });

            // load soggetti
            SoggettoEsterno.query({}, function (soggetto) {
                vm.soggettiEsterni = soggetto;
            }, function (error) {
                toastr.error('Impossibile reperire la lista dei soggetti esterni: ' + error.message, 'Errore!');
            });

            if (vm.windowsAuthEnabled) {
                vm.filteredLdapUsers = [];
                vm.loadingLdapUsers = true;
                User.fromLdap({}, function (results) {
                    vm.ldapUsers = results;
                    vm.loadingLdapUsers = false;
                }, function (error) {
                    if(error.status === 403) {
                        toastr.error($translate.instant('userManagement.error.forbidden'));
                    } else {
                        toastr.error("Errore nell'interrogazione dell'Active Directory: " + error);
                    }
                    vm.loadingLdapUsers = false;
                });
            }

            // Carica le legislature
            Atto.queryLegislature({}, function (legislature) {
                vm.legislature = legislature;
                if (vm.legislature && vm.legislature.length > 0) {
                    vm.selectedLegislaturaIndex = vm.legislature.length - 1;
                }
            }, function (error) {
                toastr.error('Impossibile reperire la lista delle legislature: ' + error.message, 'Errore!');
            });

            // Inizializza la lista di sezione authorities se non esiste
            if (!vm.user.sectionAuthorities) {
                vm.user.sectionAuthorities = [];
            }

            TipoDocumento.query({}, function(docTypes){
                vm.tipiDocumento = docTypes;
                normalizzaTipiDocumento();
            }, function (error){
                toastr.error('Impossibile reperire la lista dei tipi documento: ' + error.message, 'Errore!');
            });

            // Carica le sezioni
            Sezione.query({}, function(sezioni) {
                if(angular.isArray(sezioni)) {
                    for (var i = 0; i < sezioni.length; i++) {
                        var nomeSezione = sezioni[i];
                        var traduzione = $translate.instant('sezioni.' + nomeSezione) || nomeSezione;
                        vm.nomiSezione.push({
                            nome : nomeSezione,
                            view : traduzione
                        });
                    }
                }
            }, function(error) {
                toastr.error('Impossibile reperire la lista delle sezioni: ' + error.message, 'Errore!');
            });

        }

        function findById(array, id) {
            return findByField(array, "id", id);
        }

        function findByLegislatura(legiAuth, legislatura) {
            for (var i = 0; i < legiAuth.length; i++) {
                if (legiAuth[i]['legislatura'].legislatura === legislatura) {
                    return legiAuth[i];
                }
            }
            return null;
        }

        function findByField(array, fieldName, value) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][fieldName] === value) {
                    return array[i];
                }
            }
            return null;
        }

        // Recupera le authorities di legsilatura per la legislatura in input
        vm.getLegislaturaAuthorities = function(legislatura) {
            if(angular.isArray(vm.user.legislaturaAuthorities)) {
                return findByLegislatura(vm.user.legislaturaAuthorities, legislatura);
            } else  {
                return null;
            }
        };

        // Recupera l'oggetto CommissioneRuoloAssociato 
        // relativo alla commissione in input
        // Per la legislatura in input
        vm.getCommissioneRuoloAssociato = function(legislatura, commissione){
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth['commissioneRuoloAssociato'])) {
                for (var i = 0; i < legAuth['commissioneRuoloAssociato'].length; i++) {
                    var item = legAuth['commissioneRuoloAssociato'][i];
                    if (item.commissione && item.commissione.id === commissione.id) {
                        return legAuth.commissioneRuoloAssociato[i];
                    }
                }
            }
        };

        //------------ Funzioni di normalizzazione per riallineare gli oggetti del BE con quelli angular

        // Ruoli commissione
        function normalizzaCommissioniRuoloAssociato() {
            if (!vm.user.legislaturaAuthorities) return;
            
            // Sostituisci forEach() con cicli for per essere più sicuri
            for (var i = 0; i < vm.user.legislaturaAuthorities.length; i++) {
                var legAuth = vm.user.legislaturaAuthorities[i];
                if (legAuth.commissioneRuoloAssociato) {
                    for (var j = 0; j < legAuth.commissioneRuoloAssociato.length; j++) {
                        var item = legAuth.commissioneRuoloAssociato[j];
                        if (item.commissioneRuolo) {
                            var found = findById(vm.commissioniRuoli, item.commissioneRuolo.id);
                            if (found) {
                                item.commissioneRuolo = found;
                            }
                        }
                    }
                }
            }
        }

        // Tipi documento in SectionAuthorities
        function normalizzaTipiDocumento() {
            if (!vm.user.sectionAuthorities) return;
            
            for (var i = 0; i < vm.user.sectionAuthorities.length; i++) {
                var sectionAuth = vm.user.sectionAuthorities[i];
                var tipiNormalizzati = [];
                if (sectionAuth.tipiDocumento) {
                    for (var j = 0; j < sectionAuth.tipiDocumento.length; j++) {
                        var item = sectionAuth.tipiDocumento[j];
                        if (item.id) {
                            var found = findById(vm.tipiDocumento, item.id);
                            if (found) {
                                tipiNormalizzati.push(found);
                            }
                        }
                    }
                    sectionAuth.tipiDocumento = tipiNormalizzati;
                }
            }
        }

        // ----------- Fine Normalizzazioni

        // Ritorna 
        function filterSoggettoStoricizzato(soggettiStoricizzati, legislatura) {
            if (!soggettiStoricizzati || !legislatura) return [];
            
            // Sostituisci filter() con un ciclo for
            var filtered = [];
            for (var i = 0; i < soggettiStoricizzati.length; i++) {
                var item = soggettiStoricizzati[i];
                if (item.legislature && item.legislature.indexOf(legislatura) > -1) {
                    filtered.push(item);
                }
            }
            return filtered;
        }

        vm.isCheckedItem = function(legislatura, arrayName, value) {
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth[arrayName])) {
                if (arrayName === 'commissioneRuoloAssociato') {
                    // Cerca se esiste un oggetto con commissione.id === value.id
                    return legAuth[arrayName].some(function(item) {
                        return item.commissione && item.commissione.id === value.id;
                    });
                } else if(angular.isString(value)){
                    return legAuth[arrayName].indexOf(value) > -1;
                } else {
                    for (var j = 0; j < legAuth[arrayName].length; j++) {
                        if (legAuth[arrayName][j].id === value.id) {
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };

        vm.toggleItem = function(legislatura, arrayName, value) {
            var legAuth = vm.getLegislaturaAuthorities(legislatura);
            // Inserisce informazioni legislatura se non presenti
            if (!legAuth) {
                legAuth = { legislatura: { legislatura: legislatura } };
                legAuth[arrayName] = [];
                if (!vm.user.legislaturaAuthorities) {
                    vm.user.legislaturaAuthorities = [];
                }
                vm.user.legislaturaAuthorities.push(legAuth);
            }
            // Inserisce l'array dei permessi "arrayName" se non presente
            if (!angular.isArray(legAuth[arrayName])) {
                legAuth[arrayName] = [];
            }
            // Comportamento specifico per gli oggetti commissione (con ruolo) e soggetti esterni
            if (arrayName === 'commissioneRuoloAssociato') {

                var idxC = -1;
                for (var i = 0; i < legAuth[arrayName].length; i++) {
                    var item = legAuth[arrayName][i];
                    if (item.commissione && item.commissione.id === value.id) {
                        idxC = i;
                        break;
                    }
                }
                
                if (idxC > -1) {
                    // Se già presente, rimuovi
                    legAuth[arrayName].splice(idxC, 1);
                } else { 
                    // Se non presente inserisce l'oggetto commissioneRuoloAssociato con ruolo di default
                    legAuth[arrayName].push({ commissione: value, commissioneRuolo: null });
                }
            } else if (arrayName === 'soggettiEsterni' || arrayName === 'settori') {

                var idxE = -1;
                for (var j = 0; j < legAuth[arrayName].length; j++) {
                    if (legAuth[arrayName][j].id === value.id) {
                        idxE = j;
                        break;
                    }
                }
                
                if (idxE > -1) {
                    // Se già presente, rimuovi
                    legAuth[arrayName].splice(idxE, 1);
                } else {
                    // Se non presente inserisce il soggetto esterno
                    legAuth[arrayName].push(value);
                }
            } else {
                // Comportamento di default per elementi stringa
                var idx = legAuth[arrayName].indexOf(value);
                if (idx > -1) {
                    legAuth[arrayName].splice(idx, 1);
                } else {
                    legAuth[arrayName].push(value);
                }
            }
        };

        // Toggle authorities permanenti
        vm.togglePermanentProfile = function(value) {
            var permAuth = vm.user.authorities;
            if(permAuth) {
                var idx = permAuth.indexOf(value);
                if (idx > -1) {
                    permAuth.splice(idx, 1);
                } else {
                    permAuth.push(value);
                }
            }
        };

        // Toggle settore
        vm.toggleSettore = function(value) {
            if (!vm.user.settori) {
                vm.user.settori = [];
            }
            var settori = vm.user.settori;
            var idx = settori.indexOf(value);
            if (idx > -1) {
                settori.splice(idx, 1);
            } else {
                settori.push(value);
            }
        };

        /*  
        *      AUTHORITIES SEZIONE
        */
        // Funzione per aggiungere una Sezione Authority
        vm.addSezioneAuthority = function() {
            if(!vm.user.sectionAuthorities) {
                vm.user.sectionAuthorities = [];
            }
        
            if(!hasOneEmptyElement(vm.user.sectionAuthorities)){
                // Controlla se ci sono ancora sezioni disponibili PRIMA di aggiungere
                var availableSections = vm.getAvailableSections(vm.user.sectionAuthorities.length);
                if (availableSections.length === 0) {
                    // Tutte le sezioni assegnate
                    toastr.error('Tutte le sezioni sono già state assegnate');
                    return;
                }
                
                vm.user.sectionAuthorities.push({
                    nomeSezione: '',
                    tipiDocumento: [] 
                });
            }
        };

        function hasOneEmptyElement(sectionAuthorities) {
            if(angular.isArray(sectionAuthorities)) {
                for (var i = 0; i < sectionAuthorities.length; i++) {
                    var sezioneAuth = sectionAuthorities[i];
                    if (!sezioneAuth.nomeSezione || sezioneAuth.nomeSezione === '') {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        // Funzione per rimuovere una Sezione Authority
        vm.removeSezioneAuthority = function(index) {
            if (vm.user.sectionAuthorities && index >= 0 && index < vm.user.sectionAuthorities.length) {
                vm.user.sectionAuthorities.splice(index, 1);
            }
        };

        vm.getAvailableSections = function(currentIndex) {
            if (!vm.nomiSezione || !vm.user.sectionAuthorities) {
                return vm.nomiSezione || [];
            }

            // Sezioni già selezionate escludendo quella corrente
            var selectedSections = [];
            for (var i = 0; i < vm.user.sectionAuthorities.length; i++) {
                if (i !== currentIndex) {
                    var section = vm.user.sectionAuthorities[i].nomeSezione;
                    if (section !== null && angular.isDefined(section) && section !== '') {
                        selectedSections.push(section);
                    }
                }
            }

            // Filtra le sezioni disponibili escludendo quelle già selezionate
            var availableSections = [];
            for (var j = 0; j < vm.nomiSezione.length; j++) {
                var nomeSezione = vm.nomiSezione[j];
                var isAlreadySelected = false;
                
                for (var k = 0; k < selectedSections.length; k++) {
                    if (selectedSections[k] === nomeSezione.nome) {
                        isAlreadySelected = true;
                        break;
                    }
                }
                
                if (!isAlreadySelected) {
                    availableSections.push(nomeSezione);
                }
            }
            return availableSections;
        };

        vm.onSectionChange = function(sezioneAuth, index) {

            // TODO
            
        };
        
    }
})();
